// extracted by mini-css-extract-plugin
module.exports = {"error":"Captcha_error___ikHk"};